<template>
  <div style="overflow:hidden;">
    <div>
      <span class="xbed-sub-title">企业管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">企业管理</BreadcrumbItem>
        <BreadcrumbItem>企业列表</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="企业名称" :label-width="100">
          <FormItem>
            <Input v-model="condition.name"></Input>
          </FormItem>
        </FormItem>
        <FormItem label="联系人" :label-width="100">
          <FormItem>
            <Input v-model="condition.juridicalPerson"></Input>
          </FormItem>
        </FormItem>
        <FormItem label="企业性质" :label-width="100">
          <FormItem>
            <Select style="width:165px" v-model="condition.property">
              <Option :value="-1">全部</Option>
              <Option :value="0">国有企业</Option>
              <Option :value="1">三资企业</Option>
              <Option :value="2">集体企业</Option>
              <Option :value="3">私营企业</Option>
            </Select>
          </FormItem>
        </FormItem>
        <FormItem label="负责推广员" :label-width="100">
          <FormItem>
            <Input v-model="condition.extensionClerk" :disabled="!hasSearchPower"></Input>
          </FormItem>
        </FormItem>
      </Form>
      <Row>
        <Button type="primary" @click="queryCompanyListBtn">查找</Button>
        <Button type="warning" @click="changeDiscount">批量修改折扣</Button>
        <Button type="success" @click="editCompany">新增企业</Button>
      </Row>
      <Table class="add-distance" :columns="columns" :data="list"></Table>
      <Page class="add-distance" show-sizer :total="page.total" :page-size="page.pagesize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
    </section>
    <Modal ref="editCompanyModal" v-model="modalDisplay" :title="modalTitle" @on-ok="editCompanyBtn" @on-cancel="cancel" :loading="true">
      <Form :model="editModalData" :rules="editModalValid" ref="editCompanyForm">
        <FormItem label="企业名称" :label-width="100" prop="name">
          <Input v-model="editModalData.name" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="企业营业执照代码" :label-width="100" prop="licenseCode">
          <Input v-model="editModalData.licenseCode" :maxlength="50"></Input>
        </FormItem>
        <FormItem label="企业性质" :label-width="100" prop="property">
          <Select v-model="editModalData.property">
            <Option :value="0">国有企业</Option>
            <Option :value="1">三资企业</Option>
            <Option :value="2">集体企业</Option>
            <Option :value="3">私营企业</Option>
          </Select>
        </FormItem>
        <FormItem label="企业规模" :label-width="100" prop="scale">
          <Select v-model="editModalData.scale">
            <Option :value="0">0-50人</Option>
            <Option :value="1">51-100人</Option>
            <Option :value="2">101-500人</Option>
            <Option :value="3">501-1000人</Option>
            <Option :value="4">1000人以上</Option>
          </Select>
        </FormItem>
        <FormItem label="省份" :label-width="100" prop="provinceId">
          <Select v-model="editModalData.provinceId" @on-change="queryCityList">
            <Option v-for="item in provinceList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="市" :label-width="100" prop="cityId">
          <Select v-model="editModalData.cityId" @on-change="queryCountyList">
            <Option v-for="item in citiesList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="地区" :label-width="100" prop="areaId">
          <Select v-model="editModalData.areaId">
            <Option v-for="item in countiesList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="企业详细地址" :label-width="100" prop="address">
          <Input v-model="editModalData.address" :maxlength="100"></Input>
        </FormItem>
        <FormItem label="企业联系人" :label-width="100" prop="juridicalPerson">
          <Input v-model="editModalData.juridicalPerson" :maxlength="20"></Input>
        </FormItem>
        <FormItem label="联系人电话" :label-width="100" prop="phone">
          <Input v-model="editModalData.phone"></Input>
        </FormItem>
        <FormItem label="企业固话" :label-width="100" prop="landlineTelephone">
          <Input v-model="editModalData.landlineTelephone"></Input>
        </FormItem>
        <FormItem label="负责推广员" :label-width="100" prop="extensionClerk">
          <Input v-if="!editModalData.id" v-model="editModalData.extensionClerk" disabled></Input>
          <Select v-if="editModalData.id" v-model="editModalData.extensionClerk" filterable placeholder="editModalData.extensionClerk">
            <Option v-if="showName" :value="editModalData.extensionClerk">{{editModalData.extensionClerk}}</Option>
            <Option v-for="item in cmsList" :key="item.id" :value="item.cmsName">{{item.cmsName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="企业订房折扣" :label-width="100" prop="discount">
          <InputNumber :min="0.1" :max="0.99" :step="0.01" v-model="editModalData.discount" :disabled="!editModalData.id"></InputNumber>
        </FormItem>
        <FormItem label="员工标签" :label-width="100" prop="staffTagId">
          <Select v-model="editModalData.staffTagId">
            <Option :key="2" :value="-1">无</Option>
            <Option v-for="item in staffTagList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="营业执照" :label-width="100" prop="businessLicenceUrL">
          <input type="hidden" v-model="editModalData.businessLicenceUrL">
          <Upload ref="upload"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="4096"
            :data="uploadData"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            action="//upload.qiniup.com">
            <Button>选择文件</Button>
          </Upload>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="discountModalDisplay" title="批量修改折扣" @on-ok="changeDiscountEvent">
      <Form>
        <FormItem label="批量修改折扣" :label-width="100">
          <InputNumber v-model="discount" :min="0.1" :max="0.99" :step="0.01" ref="inputNumber" @on-focus="inputFocus"></InputNumber>
        </FormItem>
        <Table :columns="modalColumns" :data="changeDiscountCompany" @on-selection-change="selectChange"></Table>
        <Button type="success" long @click="loadingMore">加载更多</Button>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from '../../api';
import Utils from "../../utils";
import {phoneRegular, contactPhoneRegExp} from "../../utils/regular";
import Moment from 'moment'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hasSearchPower = Utils.hasPermission("oms_enterprise_findByPage");
    this.getEnterpriseStaffTagFn()
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryCompanyList();
    this.queryProvinceList();
    this.getUploadToken();
    this.queryCms();
  },
  watch: {
    editModalData(val) {
      if(val.id){
        this.showName = this.cmsList.filter((item)=>{
          return item.cmsName == val.extensionClerk;
        }).length===0
      }
    },
    discount(val) {
      if(val) {
        let stringNumber = String(val);
        if(stringNumber.length>6){
          this.discount = Number(stringNumber.substring(0,6))
          this.InputEvent.target.value = this.discount
        }else{
          this.discount = val;
        }
      }
    }
  },
  data() {
    const EXTENSIONCLERK = Utils.hasPermission("oms_enterprise_findByPage") ? '' : Utils.findFromLocalStorage("vue-username");
    return {
      staffTagList: [],
      InputEvent: '', // 获取inputNumber组件中的input对象
      showName: false,
      modalDisplay: false,
      discountModalDisplay: false,
      modalTitle: '新增企业',
      list: [],
      provinceList: [],
      citiesList: [],
      countiesList: [],
      page: {
        currentPage: 1,
        pagesize: 10,
        total: 10
      },
      condition: {
        page: Number,
        size: Number,
        name: '',
        property: -1,
        id: '',
        extensionClerk: EXTENSIONCLERK,
        juridicalPerson: ''
      },
      editModalData: {},
      editModalValid: {
        address:[
          {required: true, message: '请填写地址', trigger: 'blur' }
        ],
        areaId:[
          {required: true, type: 'number', message: '请选择区域', trigger: 'change' }
        ],
        businessLicenceUrL:[
          {required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
        cityId:[
          {required: true, type: 'number', message: '请选择城市', trigger: 'change' }
        ],
        juridicalPerson:[
          {required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        landlineTelephone:[
          {required: true, message: '请填写企业固话', trigger: 'blur' },
          {pattern: contactPhoneRegExp, message: '格式不正确', trigger: 'blur' },
        ],
        licenseCode:[
          {required: true, message: '请填写企业营业执照编码', trigger: 'blur' }
        ],
        name:[
          {required: true, message: '请填写企业名称', trigger: 'blur' }
        ],
        phone:[
          {required: true, message: '请填写联系人电话', trigger: 'blur' },
          {pattern: phoneRegular, message: '格式不正确', trigger: 'blur'}
        ],
        property:[
          {required: true, type: 'number', message: '请选择企业性质', trigger: 'change' }
        ],
        provinceId:[
          {required: true, type: 'number', message: '请选择省份', trigger: 'change' }
        ],
        scale:[
          {required: true, type: 'number', message: '请选择企业规模', trigger: 'change' }
        ],
      },
      columns: [
        {
          title: '企业ID',
          width: 100,
          align: 'center',
          key: 'id'
        },
        {
          title: '企业名称',
          width: 140,
          align: 'center',
          key: 'name'
        },
        {
          title: '企业性质',
          width: 100,
          align: 'center',
          render: (h, param) => {
            const property = ['国有企业','三资企业','集体企业','私营企业'];
            return h('span', property[param.row.property])
          }
        },
        {
          title: '企业规模',
          width: 150,
          align: 'center',
          render: (h, param) => {
            const scale = ['0-50人','51-100人','101-500人','501-1000人','1000人以上'];
            return h('span', scale[param.row.scale])
          }
        },
        {
          title: '联系人',
          width: 100,
          align: 'center',
          key: 'juridicalPerson'
        },
        {
          title: '联系电话',
          width: 150,
          align: 'center',
          key: 'phone'
        },
        {
          title: '联系固话',
          width: 150,
          align: 'center',
          key: 'landlineTelephone'
        },
        {
          title: '负责推广员',
          width: 150,
          align: 'center',
          key: 'extensionClerk'
        },
        {
          title: '企业折扣',
          width: 150,
          align: 'center',
          key: 'discount'
        },
        {
          title: '创建时间',
          width: 250,
          align: 'center',
          render: (h, params) => {
            let createdAt = params.row.createdAt ? Moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-';
            return h("div", {}, createdAt);
          }
        },
        {
          title: '操作',
          width: 240,
          align: 'center',
          render: (h, param) => {
            return h('div',[
              h('i-button',{
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editCompany(param.row)
                  }
                }
              },'修改资料'),
              h('i-button',{
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  margin: '0 5px'
                },
                on: {
                  click: () => {
                    if(this.$router){
                      this.$router.push({path: "/app/business-management/company-details", query: { id: param.row.id }})
                    }else{
                      window.open(`#/Order/Enterprise/queryDetail?id=${param.row.id}`);
                    }
                  }
                }
              },'查看'),
              h('i-button',{
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    if(!Utils.hasPermission('oms_enterprise_delete')){
                      this.$Notice.error({
                        title: '无权限操作'
                      });
                      return
                    }
                    this.$Modal.confirm({
                      title: '删除企业',
                      content: '<p>确认删除？</p>',
                      okText: '删除',
                      cancelText: '取消',
                      onOk: () => {
                        this.deleteCompany(param.row.id)
                      }
                    });
                  }
                }
              },'删除'),
            ])
          }
        },
      ],
      modalColumns: [
        {
          type: 'selection',
          width: '60px',
          align: 'center',  
        },
        {
          title: 'ID',
          width: '100px',
          align: 'center',
          key: 'id'
        },
        {
          title: '公司名称',
          width: '200px',
          align: 'center',
          key: 'name'
        },
        {
          title: '当前折扣',
          width: '100px',
          align: 'center',
          key: 'discount'
        },
      ],
      uploadData: {
        'token': '',
        'x:fileDirId:': -1,
        'x:isPrivate': 1,
        'x:remark': '' 
      },
      uploadList: [],
      countPage: 1,
      changeDiscountCompany: [],
      selectionIdsList: [],
      discount: 0.9,
      cmsList: []
    }
  },

  methods: {
    async getEnterpriseStaffTagFn() {
      let env = Utils.findFromLocalStorage( "env", "dev" )
      let protHeaders = {
        'x-ca-stage': Utils.aliHeaderEnv(env), 
        'Authorization': Utils.findFromLocalStorage("Author-token"),
        // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
      }
      let params = {
        groupId: 2,
        pageNum: 1,
        pageSize: 100,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getEnterpriseStaffTag(params, protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取员工标签列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.staffTagList = resp
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },
    inputFocus(e) {
      this.InputEvent = e;
    },
    changePage(currentPage) {
      this.page.currentPage = currentPage;
      this.queryCompanyList();
    },
    changePageSize(size) {
      this.page.currentPage = 1;
      this.page.pagesize = size;
      this.queryCompanyList();
    },
    queryCompanyListBtn() {
      this.page.currentPage = 1;
      this.queryCompanyList();
    },
    editCompany(obj) {
      if(obj.id) {
        this.queryCityList(obj.provinceId)
        this.queryCountyList(obj.cityId)
        if(!Utils.hasPermission('oms_enterprise_edit')){
          this.$Notice.error({
            title: '无权限操作'
          })
          return
        }
        this.editModalData = Object.assign({}, obj)
        this.modalTitle = '编辑企业'
      }else{
        if(!Utils.hasPermission('oms_enterprise_save')){
          this.$Notice.error({
            title: '无权限操作'
          })
          return
        }
        this.editModalData = {provinceId:1, cityId:7042, areaId:36, discount:0.9, extensionClerk:this.username}
        this.modalTitle = '新增企业'
      }
      this.modalDisplay = !this.modalDisplay;
      this.$refs.upload.clearFiles();
    },
    editCompanyBtn() {
      this.$refs.editCompanyForm.validate((valid) => {
        if (valid) {
          let editCompanyParam = Object.assign({}, this.editModalData)
          delete editCompanyParam.staffTagName
          if (!editCompanyParam.staffTagId || editCompanyParam.staffTagId === -1) {
            editCompanyParam.staffTagId = ''
          }
          this.editCompanyEvent(editCompanyParam);
          this.modalDisplay = !this.modalDisplay;
        } else {
          this.$refs.editCompanyModal.buttonLoading = false;
        }
      })
    },
    selectChange(list) {
      this.selectionIdsList = list.map((item)=>{
        return item.id
      });
    },
    changeDiscountEvent() {
      if(this.selectionIdsList.length===0){
        this.$Notice.error({
          title: '请勾选企业'
        })
        return
      }
      if(!this.discount){
        this.$Notice.error({
          title: '请调整折扣值'
        })
        return
      }
      this.changeCompanyDiscount({
        discount: this.discount,
        ids: this.selectionIdsList.join(),
      })
    },
    async changeCompanyDiscount(param) {
      let resp = (await API.omsAPI[this.env].enterpriseModule.changeCompanyDiscount(param,this.token)).data
      if(resp.retCode){
        this.$Notice.error({
          title: '修改失败',
          desc: resp.msg
        })
      }
      this.$Notice.success({
        title: '修改成功',
      })
      this.queryCompanyList();
    },
    async changeDiscount() {
      if(!Utils.hasPermission('oms_enterprise_editMore')){
        this.$Notice.error({
          title: '无权限操作'
        })
        return;
      }
      this.discount = 0.9;
      this.selectionIdsList = [];
      this.discountModalDisplay = true;
      this.countPage = 1;
      let resp = await this.queryCompanyListByCondition({
        page: this.countPage,
        size: 5,
        name: '',
        property: '',
        id: '',
        extensionClerk: '',
        juridicalPerson: ''
      });
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      this.changeDiscountCompany = resp.content;
    },
    async loadingMore() {
      ++this.countPage;
      let resp = await this.queryCompanyListByCondition({
        page: this.countPage,
        size: 5,
        name: '',
        property: '',
        id: '',
        extensionClerk: '',
        juridicalPerson: ''
      });
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      if(resp.content.length===0){
        this.$Notice.info({
          title: '无更多数据了'
        })
        return;
      }
      this.changeDiscountCompany = this.changeDiscountCompany.concat(resp.content);
      this.changeDiscountCompany = this.changeDiscountCompany.map((item)=>{
        if(this.selectionIdsList.includes(item.id)){
          item._checked = true
        }
        return item
      })
    },
    async deleteCompany(id) {
      const resp = (await API.omsAPI[this.env].enterpriseModule.deleteCompany(id,this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '删除成功'
      });
      this.queryCompanyList();
    },
    async queryProvinceList() {
      this.provinceList = (await this.getDistrictSelective()).province;
    },
    async queryCityList(parentId) {
      if(!parentId) return;
      this.citiesList = (await this.getDistrictSelective(parentId)).city;
    },
    async queryCountyList(parentId) {
      if(!parentId) return;
      this.countiesList = (await this.getDistrictSelective(parentId)).county;
    },
    async queryCompanyList() {
      this.condition.page = this.page.currentPage;
      this.condition.size = this.page.pagesize;
      let param = Object.assign({}, this.condition);
      (param.property == -1) && (param.property = '');
      let resp = await this.queryCompanyListByCondition(param);
      if(resp.retCode){
        this.$Notice.error({
          title: '获取列表失败',
          desc: resp.msg
        })
        return
      }
      this.list = resp.content;
      this.page.total = resp.total;
    },
    async queryCompanyListByCondition(condition) {
      let resp = (await API.omsAPI[this.env].enterpriseModule.queryCompanyList(
        condition,
        this.token
      )).data
      return resp;
    },
    async getDistrictSelective(parentId) {  //查询地区接口（省，市， 区）
      const resp = (await API.omsAPI[this.env].enterpriseModule.getDistrictSelective(parentId)).data;
      return resp;
    },
    async editCompanyEvent(param) {
      param.hasOwnProperty('_index') && delete param._index;
      param.hasOwnProperty('_rowKey') && delete param._rowKey;
      param.hasOwnProperty('createdAt') && delete param.createdAt;
      param.hasOwnProperty('updatedAt') && delete param.updatedAt;
      param.province = this.provinceList.filter((item)=>{
        return item.id == param.provinceId
      })[0].custName;
      param.city = this.citiesList.filter((item)=>{
        return item.id == param.cityId
      })[0].custName;
      param.area = this.countiesList.filter((item)=>{
        return item.id == param.areaId
      })[0].custName;
      if(param.businessLicenceUrL&&param.businessLicenceUrL.indexOf('?')!=-1){
        param.businessLicenceUrL = param.businessLicenceUrL.substring(0,param.businessLicenceUrL.indexOf('?'));
      }
      param.userName = this.username
      let resp = (await API.omsAPI[this.env].enterpriseModule.editCompany(
        param,
        this.token
      )).data
      if(resp.retCode){
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '操作成功'
      })
      this.editModalData = {};
      this.queryCompanyList();
    },
    async getUploadToken() {
      this.uploadData.token = (await API.omsAPI[this.env].common.getUploadToken(true, this.token)).data
    },
    async queryCms() {
      this.cmsList = (await API.omsAPI[this.env].enterpriseModule.queryCms(this.token)).data
    },
    handleSuccess (res) {
      this.editModalData.businessLicenceUrL = res.materialBase.url;
    },
    handleFormatError() {
      this.$Notice.warning({
        title: '格式不支持',
      });
    },
    handleMaxSize() {
      this.$Notice.warning({
        title: '请上传小于4M的图片',
      });
    },
    handleBeforeUpload() {
      this.$refs.upload.clearFiles()
      return true;
    },
    cancel() {
      this.editModalData = {};
    },
  }
}
</script>

<style lang="scss" scoped>
.add-distance {
  margin-top: 20px
}
</style>





// WEBPACK FOOTER //
// src/pages/business-management/index.vue